import styled, { mediaQuery, css } from 'academy-common-lib/utils/Styling';
import { LEARNING_PAGE_SIDEBAR_WIDTH } from './LearningPageSidebar';
import { jsx as _jsx } from "react/jsx-runtime";
const FullHeightScrollable = styled.div.withConfig({
  displayName: "LearningPageMainSection__FullHeightScrollable",
  componentId: "ngm8gn-0"
})(["flex-grow:1;overflow:hidden;"]);
const MaxWidth = styled.div.withConfig({
  displayName: "LearningPageMainSection__MaxWidth",
  componentId: "ngm8gn-1"
})(["max-width:100vw;margin-left:auto;margin-right:auto;padding:0;", ""], mediaQuery('notTablet', css(["max-width:1180px;width:calc(100vw - ", "px);"], LEARNING_PAGE_SIDEBAR_WIDTH)));
const LearningPageMainSection = ({
  children
}) => /*#__PURE__*/_jsx(FullHeightScrollable, {
  children: /*#__PURE__*/_jsx(MaxWidth, {
    children: children
  })
});
export default LearningPageMainSection;